import { DateTimeInput, required } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { isBeforeDate, isAfterDate } from '../../utils/validators'
import { Grid } from '@mui/material'
import { DatePeriodInputsProps } from './type'
import { useFormContext } from 'react-hook-form'
import React, { useCallback } from 'react'
const DatePeriodInputs: React.FC<DatePeriodInputsProps> = ({ startDate, endDate }) => {
  const { setValue } = useFormContext()

  React.useEffect(() => {
    setValue('start_date', startDate)
    setValue('end_date', endDate)
  }, [startDate, endDate, setValue])

  const handleChange = useCallback((event): void => {
    console.log('_event', event)
    console.log('newValue', event.target.value)
  }, [])
  
  return (
    <>
      <Grid item sm={6} md={4}>
        <DateTimeInput
          source='start_date'
          label={`${COMMON_FIELDS}.date.start_date`}
          fullWidth
          defaultValue={startDate}
          validate={[
            required(),
            isBeforeDate('end_date', 'The start date must be in before the end date.'),
          ]}
          onChange={handleChange}
        />
      </Grid>
      <Grid item sm={6} md={4}>
        <DateTimeInput
          source='end_date'
          label={`${COMMON_FIELDS}.date.end_date`}
          fullWidth
          defaultValue={endDate}
          validate={[
            required(),
            isAfterDate('start_date', 'The end date must be in after the start date.'),
          ]}
          onChange={handleChange}
        />
      </Grid>
    </>
  )
}

export default DatePeriodInputs
